// imports'
import { BrowserRouter, Routes, Route } from "react-router-dom";
// styles
import "./App.css";
// components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Reiki from "./pages/Reiki";
import SobreMi from "./pages/SobreMi";
import MiVision from "./pages/MiVision";
import Canalizacion from "./pages/Canalizacion";
import Contacto from "./pages/Contacto";
// utilities 
import ScrollToTop from "./components/ScrollToTop";

export default function App() {
    return (
        <div>
            <BrowserRouter>
                <ScrollToTop />
                <Navbar />
                <Routes>
                    <Route exact path="/" element={<Home />} />
                    <Route exact path="/reiki" element={<Reiki />} />
                    <Route exact path="/sobre_mi" element={<SobreMi />} />
                    <Route exact path="/mi_vision" element={<MiVision />} />
                    <Route
                        exact
                        path="/canalizacion"
                        element={<Canalizacion />}
                    />
                    <Route exact path="/contacto" element={<Contacto />} />
                </Routes>
                <Footer />
            </BrowserRouter>
        </div>
    );
}
